import React from "react"
import PropTypes from "prop-types"
import Card from "../../card"
import Grid from "../../grid"
import { H2, P } from "../../typography"

const Availability = ({ earliest_departure_date, latest_date_you_can_work }) => (
  <Card marginless variant="primary">
    <Grid gap="1rem">
      <H2 marginless>Availability</H2>
      <Grid gap="0.25rem">
        <P marginless bold>
          Available from:
        </P>
        <P marginless>{earliest_departure_date}</P>
      </Grid>
      <Grid gap="0.25rem">
        <P marginless bold>
          Available until:
        </P>
        <P marginless>{latest_date_you_can_work}</P>
      </Grid>
    </Grid>
  </Card>
)

Availability.propTypes = {
  earliest_departure_date: PropTypes.string,
  latest_date_you_can_work: PropTypes.string
}

Availability.defaultProps = {
  earliest_departure_date: "-",
  latest_date_you_can_work: "-"
}

export default Availability
